// components/Admin/TestInvoice.js
import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  section: {
    margin: 10,
    padding: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20,
  },
  text: {
    fontSize: 12,
    marginBottom: 5,
  }
});

// Simple PDF Document
const SimplePDF = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>TEST INVOICE</Text>
      <Text style={styles.text}>This is a test to see if page breaks happen</Text>
      <Text style={styles.text}>With just simple text content</Text>
      <Text style={styles.text}>No complex tables or formatting</Text>
      
      {/* Generate 100 lines of text to force multiple pages */}
      {[...Array(100)].map((_, i) => (
        <Text key={i} style={styles.text}>Line {i + 1}: Testing page breaks</Text>
      ))}
    </Page>
  </Document>
);

const TestInvoice = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Test PDF Generator</h1>
      <PDFDownloadLink document={<SimplePDF />} fileName="test.pdf">
        {({ loading }) => (loading ? 'Loading...' : 'Download Test PDF')}
      </PDFDownloadLink>
    </div>
  );
};

export default TestInvoice;